import filesize from 'filesize';

export const bytesAsMb = (value, digits) => {
    return (value / (1024 * 1024)).toFixed(digits);
};

export const filesizehumanreadable = (value, lang) => {
    const params = {locale: lang};

    if(!value) {
        return filesize(0, params);
    }

    return filesize(value, params);
};



// WEBPACK FOOTER //
// ./src/utils/FileUtils.js